<template>
    <div class="medical">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="患者姓名">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('patientName')" @change.capture.native="onInput($event,'patientName')" :popper-append-to-body="false" clearable v-model="filters.patientName" placeholder="请输入姓名" multiple filterable allow-create></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="病历号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('caseCode')" @change.capture.native="onInput($event,'caseCode')" :popper-append-to-body="false" clearable v-model="filters.caseCode" placeholder="请输入手机号" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="院区">
                    <el-select v-model="filters.earId" placeholder="请选择院区" style="width:95%;" clearable>
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select v-model="filters.dsepartmentCode" placeholder="请选择科室" style="width:95%;" clearable>
                        <el-option v-for="(item) in departments" :key="item.id" :label="item.departmentName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="治疗日期">
                    <el-date-picker v-model="filters.treatmentStartTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="创建日期">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <!-- <div class="delete" @click="del">删除</div>
                <div class="addData" @click="exp">导出</div> -->
                <el-button type="success" @click="exp" icon="el-icon-check">导出</el-button>
                <el-button type="danger" @click="del" icon="el-icon-delete">删除</el-button>
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="treatmentTime" label="日期"></el-table-column>
                <el-table-column sortable prop="caseCode" label="病历号" align="center"></el-table-column>
                <el-table-column sortable prop="cadCode" label="卡号" align="center"></el-table-column>
                <el-table-column sortable prop="patientName" label="姓名"></el-table-column>
                <el-table-column sortable prop="projectName" label="项目"></el-table-column>
                <el-table-column sortable prop="earName" label="院区"></el-table-column>
                <el-table-column sortable prop="sknFloor" label="楼层"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
                <el-table-column align="center" label="操作" width="110">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <brother @add-comment="appendComment" :formData="formData" @close="close"></brother>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import brother from "./brother.vue";
export default {
    name: "skinMedical",
    computed: {
        ...mapState(['departments']),
    },
    components: {
        brother
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {
                treatmentOpinions: [],
                treatmentPosition: [],
                diagnosisNo: []
            },
            tableHeight: "",
            isId: '',
            ranks: this.$store.state.ranks,
            inputName: '',
            inputmater: '',

        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        appendComment(item) {
            this.query(this.filters.pagination.page);
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        close() {
            this.dialogFormVisible = false
        },
        handleEdit(index, row) {
            this.dialogFormVisible = true
            let querys = {
                id: row.id,
            }
            api.request('/case/findSknCaseMesodermById', querys, (res) => {
                this.formData = res.data
                this.formData.treatmentOpinions = this.formData.treatmentOpinions.split(',')
                this.formData.treatmentPosition = this.formData.treatmentPosition.split(',')
                if (this.formData.diagnosisNo) {
                    this.formData.diagnosisNo = _g.turnNum(this.formData.diagnosisNo.split(','))
                } else {
                    this.formData.diagnosisNo = []
                }
            })
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                treatmentStartTime: "",
                treatmentEndTime: "",
                earId: this.filters.earId,
                patientName: this.filters.patientName.toString(),
                caseCode: this.filters.caseCode.toString()
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            if (this.filters.treatmentStartTime) {
                querys.treatmentStartTime = this.filters.treatmentStartTime[0]
                querys.treatmentEndTime = this.filters.treatmentStartTime[1]
            }
            // console.log(querys)
            api.request('/case/findSknCaseMesodermPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        // 姓名多选款
        onBlur(val) {
            if (val == 'patientName') {
                if (this.inputName != '' && !this.filters.patientName.includes(this.inputName)) {
                    this.filters.patientName.push(this.inputName)
                    this.inputName = ''
                }
            } else if (val == 'caseCode') {
                if (this.inputmater != '' && !this.filters.caseCode.includes(this.inputmater)) {
                    this.filters.caseCode.push(this.inputmater)
                    this.inputmater = ''
                }
            }
        },
        onInput(index, val) {
            if (index.target.value != '') {
                if (val == 'patientName') {
                    this.inputName = index.target.value
                } else if (val == 'caseCode') {
                    this.inputmater = index.target.value
                }
            }
        },
        // 删除项目
        del() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet("/case/deleteSknCaseMesoderm", { idList: id.toString() },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        // 导出项目
        exp() {
            let exportUrl = axios.defaults.baseURL;
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                id.push(item.id);
            });
            if (id.length == 0) {
                _g.toast("warning", '请选择要导出的数据!')
                return;
            }
            var formData = new FormData();
            formData.append("idList", id.toString())
            formData.append("createBy", Lockr.get('skinEmpId'))
            this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    axios
                        .post(
                            exportUrl + "case/wordFindSknCaseMesoderm", formData, {
                                responseType: "blob",
                            }
                        )
                        .then((res) => {
                            console.log(res)
                            const blob = new Blob([res.data], {
                                type: "application/msword",
                            });
                            // console.log(blob, '----------0990');
                            const fileName = "皮肤科门诊病历(中胚层)";
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
.medical >>> .el-form-item__content {
  line-height: 40px !important;
}
.medical >>> .el-dialog {
  width: 90% !important;
}
.no >>> .el-select-dropdown {
  display: none;
}
</style>